"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityList = void 0;
var React = require("react");
var memoize = require("fast-memoize");
var classNames = require("classnames");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var recompose_1 = require("recompose");
var moment = require("moment");
var text_1 = require("utils/text");
var sok_ui_1 = require("@caddigital/sok-ui");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var SortButton = sok_ui_1.Table.SortButton;
var enhanceHeader = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    return (0, List_1.shallowDiffers)(nextProps.style, props.style) ||
        nextProps.order !== props.order ||
        nextProps.orderBy !== props.orderBy;
}));
var SYSTEM_HEADERS = ['id', 'email', 'name', 'timestamp', 'project'];
var SOKOBID_HEADERS = [
    'id',
    'email',
    'name',
    'timestamp',
    'bid_name',
    'letter_name',
    'participant_email'
];
var Header = enhanceHeader(function (_a) {
    var style = _a.style, className = _a.className, order = _a.order, orderBy = _a.orderBy, setOrder = _a.setOrder, headers = _a.headers;
    return (React.createElement("div", { className: className + ' row', style: style },
        React.createElement("div", { className: "row__column narrow" }),
        headers.map(function (header) {
            var dataKey = '__' + header.replace(/-/g, '');
            return (React.createElement("div", { className: 'row__column ' + dataKey },
                React.createElement("div", null, (0, translation_1.getLocalization)("userfront/admin/activity/header/".concat(header))),
                React.createElement(SortButton, { className: "d-none d-desktop-table-cell", disabled: false, order: header === orderBy ? order : undefined, onChange: function () {
                        setOrder(header, header !== orderBy
                            ? 'asc'
                            : order === 'asc'
                                ? 'desc'
                                : 'asc');
                    } })));
        })));
});
var ListRow = function (headers) {
    return React.memo(function (_a) {
        var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
        var items = data.items;
        var activity = items[index];
        var elements = [
            React.createElement("div", { className: "row__column narrow" })
        ];
        for (var i = 0; i < headers.length || 0; i++) {
            var key = headers[i];
            var dataKey = '__' + headers[i].replace(/-/g, '');
            var value = activity[key];
            elements.push(React.createElement("div", { "data-length": (value || '').toString().length, key: headers[i], className: classNames('row__column ' + dataKey, data.openActivityDetails && 'clickable') }, key === 'timestamp' ? (React.createElement("span", null, moment(value).format('L HH:mm'))) : key === 'name' ? (React.createElement("span", null, (0, translation_1.getLocalization)(value))) : (React.createElement("span", null, value))));
        }
        return (React.createElement("div", { className: className, style: style, onClick: function () {
                return data.openActivityDetails && data.openActivityDetails(activity);
            } }, elements));
    }, function (nextProps, props) { return !(0, List_1.shallowDiffers)(nextProps, props); });
};
function calcFields(activities, setContentWidth, type) {
    var headers = type === 'sokobid' ? SOKOBID_HEADERS : SYSTEM_HEADERS;
    var contentWidth = 36;
    var columns = activities.reduce(function (p, item) {
        headers.forEach(function (c) {
            var dataKey = '__' + c.replace(/-/g, '');
            var value = item[c];
            var text = (value ? value : '-').toString();
            var prevValue = p[dataKey];
            var length = (0, text_1.calculateStringLength)(c === 'name' ? (0, translation_1.getLocalization)(text) : text);
            if (prevValue && prevValue.length < length) {
                prevValue.text = text;
                prevValue.length = length;
            }
            else if (!prevValue) {
                p[dataKey] = {
                    text: text,
                    length: length
                };
            }
        });
        return p;
    }, {});
    headers.forEach(function (x) {
        var dataKey = '__' + x.replace(/-/g, '');
        var text = (0, translation_1.getLocalization)('userfront/admin/activity/header/' + x);
        var length = (0, text_1.calculateStringLength)(text) + 36;
        var prevValue = columns[dataKey];
        if (prevValue && prevValue.length < length) {
            prevValue.text = text;
            prevValue.length = length;
        }
        else if (!prevValue) {
            columns[dataKey] = {
                text: text,
                length: length
            };
        }
    });
    var lengths = Object.keys(columns).reduce(function (prev, x) {
        prev[x] = columns[x].length;
        return prev;
    }, {});
    // Override styles for dynamic classes
    var style = document.getElementById('ActivityListCSS');
    if (style && style.parentNode) {
        style.parentNode.removeChild(style);
    }
    style = document.createElement('style');
    style.id = 'ActivityListCSS';
    document.head && document.head.appendChild(style);
    var sheet = style.sheet;
    Object.keys(lengths).forEach(function (className, i) {
        var colwidth = Math.max(8, 4 + lengths[className] + 36); // convert to rem
        contentWidth += colwidth;
        sheet.insertRule(".".concat(className) +
            ' {max-width: ' +
            colwidth +
            'px;\n min-width: ' +
            colwidth +
            'px;}', i);
    });
    setContentWidth(contentWidth);
}
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('element', 'setElement', null), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        calcFields(this.props.activities, this.props.setContentWidth, this.props.type);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.activities !== prevProps.activities ||
            prevProps.contentWidth === 0) {
            calcFields(this.props.activities, this.props.setContentWidth, this.props.type);
        }
    }
}), (0, recompose_1.onlyUpdateForKeys)(['orderBy', 'order', 'contentWidth', 'activities']));
var createRowData = memoize(function (items, openActivityDetails) { return ({
    items: items,
    openActivityDetails: openActivityDetails
}); });
exports.ActivityList = enhance(function (props) {
    var items = props.activities || [];
    var itemData = createRowData(items, props.type === 'system' ? props.openActivityDetails : undefined);
    return (React.createElement("div", { className: 'activity-list-container' },
        React.createElement("div", { className: 'activity-list' },
            React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(sok_ui_1.List, { itemCount: items.length, itemData: itemData, overscanCount: 8, width: width, height: Math.min((items.length + 1) * 50, height), itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, { order: props.order, orderBy: props.orderBy, setOrder: props.setOrder, headers: props.type === 'sokobid' ? SOKOBID_HEADERS : SYSTEM_HEADERS }) }, ListRow(props.type === 'sokobid' ? SOKOBID_HEADERS : SYSTEM_HEADERS)));
            }))));
});
